var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"chart"},[_c('b-loading',{attrs:{"active":_vm.loading,"is-full-page":true,"can-cancel":false}}),(_vm.data)?_c('simple-line',_vm._b({},'simple-line',_vm.data,false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }